import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import personalFinanceIcon from '../../../images/insight360/360-personal-finance-icon.png';
import petsIcon from '../../../images/insight360/360-pets-icon.png';
import printMediaIcon from '../../../images/insight360/360-print-media-icon.png';
import moviesIcon from '../../../images/insight360/360-prod-plcmnt-movies-icon.png';
import tvIcon from '../../../images/insight360/360-prod-plcmnt-tv-icon.png';
import shoppingIcon from '../../../images/insight360/360-shopping-icon.png';
import spanishIcon from '../../../images/insight360/360-spanish-language-icon.png';
import techIcon from '../../../images/insight360/360-tech-icon.png';
import tobaccoIcon from '../../../images/insight360/360-tobacco-icon.png';
import travelIcon from '../../../images/insight360/360-travel-icon.png';
import apparelIcon from '../../../images/insight360/360-apparel-icon.png';
import autoIcon from '../../../images/insight360/360-auto-icon.png';
import cellphonesIcon from '../../../images/insight360/360-cellphones-icon.png';
import cleaningProductsIcon from '../../../images/insight360/360-cleaning-products-icon.png';
import diningIcon from '../../../images/insight360/360-dining-icon.png';
import foodIcon from '../../../images/insight360/360-food-icon.png';
import healthBeautyIcon from '../../../images/insight360/360-health-beauty-icon.png';
import healthyMedsIcon from '../../../images/insight360/360-health-meds-icon.png';
import homeIcon from '../../../images/insight360/360-home-icon.png';
import internetIcon from '../../../images/insight360/360-internet-icon.png';
import lifestyleIcon from '../../../images/insight360/360-lifestyle-icon.png';
import none from '../../../images/insight360/clear-field-icon_190-190-190.png';
// MRI Brands..
import mriBabyIcon from '../../../images/mri-icons/360-mri-baby-icon.png';
import mriBeveragesIcon from '../../../images/mri-icons/360-mri-beverages-icon.png';
import mriCandyIcon from '../../../images/mri-icons/360-mri-candy-icon.png';
import mriLeisureSportsIcon from '../../../images/mri-icons/360-mri-leisure-sports-icon.png';
import mriNewspaperIcon from '../../../images/mri-icons/360-mri-newspaper-icon.png';
import mriNonFoodProductsIcon from '../../../images/mri-icons/360-mri-non-food-products-icon.png';
import mriOccupationIcon from '../../../images/mri-icons/360-mri-occupation-icon.png';
import mriPersonalItemIcon from '../../../images/mri-icons/360-mri-personal-item-icon.png';
import mriPetsIcon from '../../../images/mri-icons/360-mri-pets-icon.png';
import mriTobaccoIcon from '../../../images/mri-icons/360-mri-tobacco-icon.png';
import mriRadioIcon from '../../../images/mri-icons/360-mri-tv-watching-icon.png';
import mriBuyingStyleIcon from '../../../images/mri-icons/360-mri-buying-style-icon.png';
import mriFinanceIcon from '../../../images/mri-icons/360-mri-finance-icon.png';
import mriHomeIcon from '../../../images/mri-icons/360-mri-home-icon.png';
import mriTelevisionIcon from '../../../images/mri-icons/360-mri-television-icon.png';
import mriTravelIcon from '../../../images/mri-icons/360-mri-travel-icon.png';

const header = ['TOP 5 BRANDS', 'TOP 5 MEDIA'];
const topSize = 5;

const iconComponents = [
  { id: 'clearFieldIcon190190190', selectedIcon: none },
  { id: '360InternetIcon', selectedIcon: internetIcon },
  { id: '360LifestyleIcon', selectedIcon: lifestyleIcon },
  { id: '360PersonalFinanceIcon', selectedIcon: personalFinanceIcon },
  { id: '360PetsIcon', selectedIcon: petsIcon },
  { id: '360PrintMediaIcon', selectedIcon: printMediaIcon },
  { id: '360ProdPlcmntMoviesIcon', selectedIcon: moviesIcon },
  { id: '360ProdPlcmntTvIcon', selectedIcon: tvIcon },
  { id: '360ShoppingIcon', selectedIcon: shoppingIcon },
  { id: '360SpanishLanguageIcon', selectedIcon: spanishIcon },
  { id: '360TechIcon', selectedIcon: techIcon },
  { id: '360TobaccoIcon', selectedIcon: tobaccoIcon },
  { id: '360TravelIcon', selectedIcon: travelIcon },
  { id: '360ApparelIcon', selectedIcon: apparelIcon },
  { id: '360AutoIcon', selectedIcon: autoIcon },
  { id: '360CellphonesIcon', selectedIcon: cellphonesIcon },
  { id: '360CleaningProductsIcon', selectedIcon: cleaningProductsIcon },
  { id: '360DiningIcon', selectedIcon: diningIcon },
  { id: '360FoodIcon', selectedIcon: foodIcon },
  { id: '360HealthBeautyIcon', selectedIcon: healthBeautyIcon },
  { id: '360HealthMedsIcon', selectedIcon: healthyMedsIcon },
  { id: '360HomeIcon', selectedIcon: homeIcon },
  // Mri Brands Icons..
  { id: '360BabyIcon', selectedIcon: mriBabyIcon },
  { id: '360BeveragesIcon', selectedIcon: mriBeveragesIcon },
  { id: '360CandyIcon', selectedIcon: mriCandyIcon },
  { id: '360LeisureSportsIcon', selectedIcon: mriLeisureSportsIcon },
  { id: '360NewspaperIcon', selectedIcon: mriNewspaperIcon },
  { id: '360NonFoodProductsIcon', selectedIcon: mriNonFoodProductsIcon },
  { id: '360OccupationIcon', selectedIcon: mriOccupationIcon },
  { id: '360PersonalItemIcon', selectedIcon: mriPersonalItemIcon },
  { id: '360HhPetsIcon', selectedIcon: mriPetsIcon },
  { id: '360TobaccoProductsIcon', selectedIcon: mriTobaccoIcon },
  { id: '360TvWatchingIcon', selectedIcon: mriRadioIcon },
  { id: '360BuyingStyleIcon', selectedIcon: mriBuyingStyleIcon },
  { id: '360FinanceIcon', selectedIcon: mriFinanceIcon },
  { id: '360HomeImprovementIcon', selectedIcon: mriHomeIcon },
  { id: '360TelevisionIcon', selectedIcon: mriTelevisionIcon },
  { id: '360TravelPlanningIcon', selectedIcon: mriTravelIcon },
  { id: '360PetsIcon', selectedIcon: mriPetsIcon },
  { id: '360TobaccoProductsIcon', selectedIcon: mriTobaccoIcon },
];

class ProfilesSingleTops extends Component {

  getImageIcon = imageKey => {
    const imageComponent = _.find(iconComponents, { id: imageKey });
    if (imageComponent !== undefined) {
      return imageComponent.selectedIcon;
    }
    return undefined;
  }

  resize = (arr, newSize, defaultValue) => {
    const tempArr = arr;
    while (newSize > tempArr.length) tempArr.push(defaultValue);
    tempArr.length = newSize;
    return tempArr;
  }

  fill(brandsOrMedia) {
    let profileData = brandsOrMedia;
    if (brandsOrMedia.length < topSize) {
      profileData = this.resize(brandsOrMedia, topSize, {
        brandCategory: 'N/A',
        brandLabel: 'N/A',
        icon: 'clear-field-icon_190-190-190.png',
        index: 'N/A',
        weighted: 'N/A',
        sample: 'N/A',
        pct: 'N/A',
      });
    }
    return profileData;
  }

  render() {
    return (
      <div className="row demographic-detail-columns fullwidth">
        <div className="columns large-2 small-2 medium-2">
          <p className="profile-top5-header">
            {this.props.index !== undefined ? header[this.props.index] : ''}
          </p>
        </div>
        {this.props.brands !== undefined &&
          this.fill(this.props.brands.brandList.slice(0, topSize)).map(
            (brand, i) => (
              <div
                key={`prof-s-top${i}`}
                className={
                  i > 0
                    ? 'columns large-2 small-2 medium-2 text-align-center'
                    : 'columns large-2 small-2 medium-2  text-align-center'
                }
              >
                {this.getImageIcon(
                  _.camelCase(brand.icon.replace('.png', '')),
                ) === undefined && <div className="imageblock" />}
                {this.getImageIcon(
                  _.camelCase(brand.icon.replace('.png', '')),
                ) !== undefined && (
                  <img
                    className="profile-top5-img"
                    src={this.getImageIcon(
                      _.camelCase(brand.icon.replace('.png', '')),
                    )}
                    alt={brand.brandLabel}
                    key={brand.brandLabel}
                  />
                )}
                <p className="profile-top-brand-media-catagory">
                  {brand.brandCategory}
                </p>
                <div
                  className="row"
                  id="profile-single-tops-text-labels-height"
                  title={brand.brandLabel}
                >
                  <p className="profile-single-tops-text">
                    {brand.brandLabel}</p>
                </div>
                <div className="div-overflow">
                  <div className="profile-tops-statement-matrix">
                    INDEX:&nbsp;&nbsp;{brand.index} | REACH:&nbsp;&nbsp;
                    {brand.pct}{' '}
                  </div>
                </div>
              </div>
            ))}
      </div>
    );
  }

}

ProfilesSingleTops.propTypes = {
  brands: PropTypes.shape({}),
};

export default connect(
  null,
  null,
  null,
  { forwardRef: true },
)(ProfilesSingleTops);
